<div class="auth-body">
    <div class="card-container">
        <div class="card-inner">
            <img src="../../../../assets/icons/UPS_LOGO.svg" alt="UPS Logo" class="logo">
            
            <h1 class="headline">Welcome to UPS Wallet</h1>
            <div class="yellow-line"></div>

            <p class="description">Ship with UPS and earn rewards points</p>

            <button class="btn-continue" (click)="onLogin()">Continue >></button>

            <button (click)="onLogout()" style="margin-left: 20px; background: red; color: white;">
  Reset / Logout
</button>
        </div>
    </div>
</div>

<footer class="app-footer">
    <p>&copy; 2026 UPS Company. All Rights Reserved.</p>
</footer>
